<app-si-dialog
	modalBodyClasses="flex flex-col h-full w-full overflow-hidden p-4 min-h-[200px]"
	header="Export to Outreach"
	[isLoading]="isLoading$ | async"
>
	<ng-template appDialogBody>
		<ng-container *ngIf="accuracyTier">
			<div class="mb-4 text-center rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm">{{accuracyTierText}}</div>
		</ng-container>

		<div class="flex flex-col overflow-hidden">
			<div *ngIf="isBusy">

				<div class="flex flex-wrap -mx-2">

					<div class="w-full md:flex-none md:w-full text-center px-2">
						<b>{{busyLabel}}</b><br />
						{{busySublabel}}
					</div>
					<div class="flex-none w-1/12 px-2">
					</div>
				</div>
			</div>

			<div *ngIf="currentPage == pages.tags && !isBusy">

				<div class="pl-2 pr-2">
					<h3>Tags (optional)</h3>
					Enter tags, comma separated, for the selected contacts. This is optional.
					<br /><br />

					<mat-form-field appearance="outline" class="mb-1 w-full">
						<mat-label>Enter tags</mat-label>
						<input matInput type="text" placeholder="Enter tags" [(ngModel)]="tags" />
					</mat-form-field>
				</div>
			</div>

			<ng-container *ngIf="currentPage == pages.sequence && !isBusy">
				<h3>Sequence (optional)</h3>
				<!-- Select the sequence you want to assign the selected contacts to. This is optional. -->
				<div class="flex items-center mb-4">
					<span class="mr-4">Choose Mapping Style</span>
					<mat-radio-group [(ngModel)]="individualFlow">
						<mat-radio-button class="mr-4" name="flow" [value]="false" (click)="toggleFlow($event,false)">Basic Assignment</mat-radio-button>
						<mat-radio-button name="flow" [value]="true" (click)="toggleFlow($event,true)">Advance Assignment</mat-radio-button>
					</mat-radio-group>
				</div>
				<ng-container *ngIf="individualFlow === false">
					<div class="w-full md:flex-none md:w-full pl-0 pr-0">
						<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
							<mat-label>Filter by name</mat-label>
							<input matInput type="text" placeholder="Filter by name" [(ngModel)]="sequenceFilter">
							<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
						</mat-form-field>
					</div>
					<div class="table-scroll">
						<table class="table-fixed border pt-1 si-table">
							<thead>
							<tr>
								<th class="flex-none w-11/12 px-2">
									Name
								</th>
								<th class="flex-none w-1/12 px-2">
									&nbsp;
								</th>
							</tr>
							</thead>
							<tbody>
							<tr (click)="selectSequence(sequence.id)"
								*ngFor="let sequence of sequences | filter : sequenceFilter | orderBy : 'name'">
								<td class="flex-none w-11/12 px-2">{{ sequence.name }}</td>
								<td class="flex-none w-1/12 px-2"><fa-icon *ngIf="rowSelected(sequence.id)" [icon]="['fas', 'check']"></fa-icon>
								</td>
							</tr>
							<tr *ngIf="(sequences | filter: sequenceFilter).length === 0">
								<td colspan="2" class="flex-none w-full text-center px-2"><br /><br /><i>No Sequences Found</i></td>
							</tr>
							</tbody>
						</table>
					</div>
				</ng-container>
				<ng-container *ngIf="individualFlow === true">
					<app-individual-assignment
						class="flex flex-col overflow-hidden"
						[selectedContacts]="contacts"
						[type]="exportType"
						[optionsList]="sequences"
						(exportIds)='onIndividual($event)'
					></app-individual-assignment>
				</ng-container>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.leadOwner && !isBusy">
				<h3>Contact Owner (optional)</h3>
				Select an owner for the selected contacts. This is optional.
				<br /><br />
				<div class="flex-none w-full pl-0 pr-0 pb-2">
					<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
						<mat-label>Filter by name or email</mat-label>
						<input matInput type="text" placeholder="Filter by name or email" [(ngModel)]="filterLeadOwner">
						<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
					</mat-form-field>
				</div>

				<div class="table-scroll">
					<table class="table-fixed si-table si-table--striped si-table--hover si-table--grid">
						<thead>
						<tr>
							<th class="flex-none w-1/2 px-2">
								Name
							</th>
							<th class="flex-none w-5/12 px-2">
								Email
							</th>
							<th *ngIf="(leadOwners | filter: filterLeadOwner).length > 0" class="flex-none w-1/12 px-2">
								&nbsp;
							</th>
						</tr>
						</thead>
						<tbody>
						<tr (click)="selectLeadOwner(leadowner.id)"
							*ngFor="let leadowner of leadOwners | filter: filterLeadOwner | orderBy : 'name'">

							<td class="flex-none w-1/2 px-2">{{ leadowner.name }}</td>
							<td class="flex-none w-5/12 px-2">{{ leadowner.email }}</td>
							<td class="flex-none w-1/12 text-center px-0">
								<fa-icon [hidden]="leadowner.id !== selectedContactOwner" class="py-0" [icon]="['fas', 'check']"></fa-icon>
							</td>

						</tr>
						<tr *ngIf="(leadOwners | filter: filterLeadOwner).length === 0">
							<td colspan="2" class="flex-none w-full text-center bg-white py-6 px-2">
								<i>No {{ exportType}} Owners Found</i>
							</td>
						</tr>
						</tbody>
					</table>
				</div>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.mailbox && !isBusy">
				<h3>Mailbox <span *ngIf="selectedSequence === ''">(optional)</span></h3>
				Select the mailbox you want to use with the selected sequence.
				<br /><br />
				<div class="w-full md:flex-none md:w-full pl-0 pr-0">
					<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
						<mat-label>Filter by name</mat-label>
						<input matInput type="text" placeholder="Filter by name" [(ngModel)]="mailboxFilter">
						<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
					</mat-form-field>
				</div>
				<div class="table-scroll">
					<table class="table-fixed border si-table">
						<thead>
						<tr>
							<th class="flex-none w-11/12 px-2">
								Name
							</th>
							<th class="flex-none w-1/12 px-2">
								&nbsp;
							</th>
						</tr>
						</thead>
						<tbody>
						<tr (click)="selectMailbox(mailbox.id)"
							*ngFor="let mailbox of mailboxes | filter : mailboxFilter | orderBy : 'email'">
							<!-- | filter : mailboxFilter -->
							<td class="flex-none w-11/12 px-2">{{ mailbox.email }}</td>
							<td class="flex-none w-1/12 px-2"><fa-icon *ngIf="isMailboxSelected(mailbox.id)" [icon]="['fas', 'check']"></fa-icon></td>
						</tr>
						<tr *ngIf="(mailboxes | filter: mailboxFilter).length === 0">
							<td colspan="2" class="flex-none w-full text-center bg-white px-2">
								<br /><br /><i>No
								Mailbox Found</i></td>
						</tr>
						</tbody>
					</table>
				</div>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.duplicates && !isBusy">
				<h3>Duplicates</h3>

				<div class="flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-1/2 px-2">
						<b>Found {{duplicateCount}} duplicate<span *ngIf="duplicateCount != 1">s</span>:</b>
					</div>
					<div class="w-full md:flex-none md:w-1/2 px-2">
						<b>Resolve Duplicates by:</b>
					</div>
				</div>

				<div class="flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-1/2 table-scroll px-2">
						<table class="table-fixed border si-table" style="max-height: 36vh;overflow-y:auto;">
							<tbody>
							<tr *ngFor="let match of duplicateMatchIds">
								<td class="flex-none w-full px-2">{{ match.contact_name }}
								</td>
							</tr>
							</tbody>
						</table>
					</div>
					<div class="flex-none w-1/2 px-2">
						<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.exportFinished && !isBusy">
				<div class="flex flex-wrap -mx-2">
					<div class="w-full md:flex-none md:w-full text-center px-2">
						<h3>Export Succeeded</h3>
						You have successfully exported {{exportedContactCount}} contact<span
							*ngIf="exportedContactCount != 1">s</span> as prospect<span
							*ngIf="exportedContactCount != 1">s</span> to Outreach.
						<br /><br />
						<div *ngIf="warnings.length > 0" class="rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm" role="alert">All contacts were
							exported, but for some of the contacts we ran into validation issues.<br /><br /><button
									matButton="outlined"
									type="button"
									class="mat-small-button mat-secondary"
									(click)="showWarnings()"
							>view details</button></div>
						<br />
						<pre class="text-left text-danger" *ngIf="isShowingWarnings"
							 style="max-height: 200px; overflow-y: scroll; white-space: pre-wrap; text-align: left;">{{warnings | json}}</pre>
						<br />
					</div>
				</div>
			</ng-container>

			<ng-container *ngIf="currentPage == pages.exportEmpty && !isBusy">
				<div style="min-height: 250px;" class="text-center pl-2 pr-2">
					<h3>Nothing to Export</h3>
					All selected contacts are duplicates and you decided to skip duplicates, so there's nothing left to export.
				</div>
			</ng-container>
			<ng-container *ngIf="currentPage == pages.exportFailed && isBusy == false">
				<div style="min-height: 250px;" class="pl-2 pr-2">
					<h3>Export Failed</h3>
					Your export failed with the following error: <br /><br />
					<pre class="text-danger" style="max-height: 200px;white-space: pre-wrap;">{{exportError}}</pre><br />
					Please resolve the problem in your Outreach instance and retry or contact SalesIntel support at <a
						href="mailto:support@salesintelio">support&#64;salesintel.io</a>.
				</div>
			</ng-container>
			<ng-container *ngIf="currentPage == pages.exportError && isBusy == false">
				<div style="min-height: 250px;" class="pl-2 pr-2">
					<h3>Export Failed</h3>
					Your export failed with the following error: <br /><br />
					<pre class="text-danger" style="max-height: 200px;white-space: pre-wrap;">{{exportError}}</pre><br />
					Please resolve the problem in your Outreach instance and retry or contact SalesIntel support at <a
						href="mailto:support@salesintelio">support&#64;salesintel.io</a>.
				</div>
			</ng-container>
		</div>
	</ng-template>
	<ng-template appDialogFooter>
		<div>
			<a matButton="outlined" type="button" (click)="retryExport()"
			   *ngIf="showRetryButton">Retry</a>&nbsp;
			<button matButton="outlined" type="button" *ngIf="showCancelButton"
					(click)="onClose()">Cancel</button>
		</div>
		<div>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="showPreviousButton"
					[disabled]="isLoading$ | async"
					(click)="previous()">Previous</button>
			<button matButton="filled" type="button" class="ml-2" *ngIf="!isBusy && showNextButton" (click)="next()"
					[disabled]="isButtonDisable || (isLoading$ | async)">Next</button>
			<button matButton="outlined" *ngIf="showCloseButton" (click)="onClose()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
